// components/InstallPWA.tsx
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';

let deferredPrompt: any;

const InstallPWA: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const alreadyShown = sessionStorage.getItem('pwaPromptShown');
    if (alreadyShown) return; // اگه قبلاً نشون داده شده، دوباره نشون نده

    const handleBeforeInstallPrompt = (e: any) => {
      e.preventDefault();
      deferredPrompt = e;
      if (isMobile) {
        setIsVisible(true);
        sessionStorage.setItem('pwaPromptShown', 'true'); // ذخیره در sessionStorage
      }
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const choiceResult = await deferredPrompt.userChoice;
    if (choiceResult.outcome === 'accepted') {
      console.log('User accepted install');
    }
    deferredPrompt = null;
    setIsVisible(false);
  };

  const handleClosePopup = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
      <div className="bg-white rounded-xl shadow-xl p-6 max-w-sm w-full relative">
        <button
          onClick={handleClosePopup}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
        >
          ✕
        </button>
        <h2 className="text-lg font-semibold mb-2">نصب اپلیکیشن</h2>
        <p className="text-sm text-gray-600 mb-4">
          برای دسترسی سریع‌تر، اپلیکیشن رو روی دستگاه خود نصب کنید.
        </p>
        <div className="flex gap-3">
          <button
            onClick={handleInstallClick}
            className="flex-1 bg-red-600 text-white py-2 rounded-lg hover:bg-red-700 transition"
          >
            نصب
          </button>
          <button
            onClick={handleClosePopup}
            className="flex-1 bg-gray-200 text-gray-800 py-2 rounded-lg hover:bg-gray-300 transition"
          >
            بعداً
          </button>
        </div>
      </div>
    </div>
  );
};

export default InstallPWA;
